export const SHOW_ALERT = 'SHOW_ALERT_ACTION';
export const HIDE_ALERT = 'HIDE_ALERT_ACTION';
export const SHOW_DIALOG = 'SHOW_DIALOG_ACTION';
export const HIDE_DIALOG = 'HIDE_DIALOG_ACTION';

export const CONFIRM_DIALOG = 'CONFIRM_DIALOG';
export const ALERT_DIALOG = 'ALERT_DIALOG';
export const SNACKBAR = 'SNACKBAR';

export const SEND_SMS_DIALOG = 'SEND_SMS_DIALOG';
export const SEND_EMAIL_DIALOG = 'SEND_EMAIL_DIALOG';

export const ASSIGN_EMPLOYEES_TO_STAGES_DIALOG = 'ASSIGN_EMPLOYEES_TO_STAGES_DIALOG';
export const ADD_ACCOUNT_DIALOG = 'ADD_ACCOUNT_DIALOG';
export const ACCOUNT_DIALOG = 'ACCOUNT_DIALOG';
export const CREDIT_CARD_DIALOG = 'CREDIT_CARD_DIALOG';
export const UPGRADE_DIALOG = 'UPGRADE_DIALOG';

export const PROFILE_DIALOG = 'PROFILE_DIALOG';

export const CREATE_JOB_DIALOG = 'CREATE_JOB_DIALOG';
export const FIND_JOB_DIALOG = 'FIND_JOB_DIALOG';

export const CUSTOMER_DIALOG = 'CUSTOMER_DIALOG';

export const TASK_DIALOG = 'TASK_DIALOG';
export const TASK_UPLOAD_DIALOG = 'TASK_UPLOAD_DIALOG';
export const ADDRESS_DIALOG = 'ADDRESS_DIALOG';
export const CONTACT_DIALOG = 'CONTACT_DIALOG';

export const EMPLOYEE_DIALOG = 'EMPLOYEE_DIALOG';
export const GENERATE_LABELS_DIALOG = 'GENERATE_LABELS_DIALOG';
export const TASK_PHOTOS_DIALOG = 'TASK_PHOTOS_DIALOG';
export const STAGE_DIALOG = 'STAGE_DIALOG';
export const JOB_PROFILE_DIALOG = 'JOB_PROFILE_DIALOG';
export const JOB_DIALOG = 'JOB_DIALOG';
export const PRINTER_DIALOG = 'PRINTER_DIALOG';
export const QUALITY_CONTROL_QUESTION_DIALOG = 'QUALITY_CONTROL_QUESTION_DIALOG';
export const ROLE_DIALOG = 'ROLE_DIALOG';
export const ASSIGN_RESOURCES_DIALOG = 'ASSIGN_RESOURCES_DIALOG';
export const ASSIGN_RESOURCES_TO_TASKS_DIALOG = 'ASSIGN_RESOURCES_TO_TASKS_DIALOG';
export const TASK_PROFILE_DIALOG = 'TASK_PROFILE_DIALOG';
export const LOADING_DIALOG = 'LOADING_DIALOG';
export const IDENTITY_DIALOG = 'IDENTITY_DIALOG';

export const EXCEPTION_DIALOG = 'EXCEPTION_DIALOG';

// export const _DIALOG = '';
// export const _DIALOG = '';
// export const _DIALOG = '';
// export const _DIALOG = '';
// export const _DIALOG = '';



// WEBPACK FOOTER //
// ./src/redux/constants/dialogs.js